import React from 'react';
import { useEffect } from 'react';
import PageHeader from '../../components/pageHeader/PageHeader';
import About from '../../components/about/About';
import Contact from '../../components/contact/Contact';
import Footer from '../../components/footer/Footer';

export default function AboutPage() {
    useEffect(() => {
        window.scrollTo(0,0);
    }, [])

    return(
        <section>
            <PageHeader page="about"/>
            <About />
            <Contact />
            <Footer />
        </section>
    )
}
